(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.property.view
  (:require
   [clojure.set :as set]
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
    :refer [portfolio-locations-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.style :as style]
   [frontend.ui.component.lp-portal.stacked-text-group.view
    :refer
    [stacked-text-group]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.card.style :as card-style]
   [herb.core :as h]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.view :as esg]))

(defn property-section
  [{:keys [holding-name overview business-plan-text investment-rationale-text
           access-management-update-text esg-text
           map-data investment-at-cost-and-valuation noi]}
   props]
  [section
   holding-name
   nil
   [:div
    [grid/row {}
     [grid/column {:span 12}
      [card
       {:title ""}
       [:<>
        [free-text-card/free-text-section "Investment Rationale" investment-rationale-text props]
        [free-text-card/free-text-section "Business Plan" business-plan-text props]
        [free-text-card/free-text-section "Asset Management Update" access-management-update-text
         props]
        #_[free-text-card/free-text-section "Sustainability" esg-text props]]
       [:div
        [tabular-card/dynamic-stacked-table overview props]
        [portfolio-locations-card map-data props]]]]]
    #_[grid/row {}
       [grid/column {:span 6}
        [card {}
         "TODO Property picture"]]
       [grid/column {:span 6}
        [portfolio-locations-card map-data]]]
    [grid/row {}
     [grid/column {:span 6}
      [chart-card/view "Gross investment at cost & valuation"
       investment-at-cost-and-valuation props]]
     [grid/column {:span 6}
      [chart-card/view "NOI" noi props]]]]])

(defn property
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [property-section holding-ui-data props]]))

(defn property-esg
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [property-section holding-ui-data props]
     [esg/esg-section holding-ui-data props]]))


(defn portfolio-esg
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [property-section holding-ui-data props]
     [esg/portfolio-esg-section holding-ui-data props]]))
